import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useCharacteristicInit } from "./hooks/useCharacteristicInit";
import { useOverrideToggle } from "./hooks/useOverrideToggle";
import { useCharStatus } from "./hooks/useCharStatus";
import { useTabList } from "./hooks/useTabList";
import { useDefaultIndex } from "./hooks/useDefaultIndex";
import { VerticalTab } from "../../../secondary";
import { Spinner } from "../../../secondary/Loader/Spinner";
import { detailAssessmentAsync } from "../../../../app/patientSlice";

export const Characteristic = ({ hideIt }) => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();

  const assessmentDetails = useSelector((state) => state.patient.detailAssessment);
  const charStatus = useSelector((state) => state.patient.charStatus);

  const [showwound, setShowWound] = useState(false);

  const overrideToggle = useOverrideToggle();
  const { updateCharStatus } = useCharStatus();

  const getCharDetails = () => {
    dispatch(detailAssessmentAsync({ patientId, assessmentId }));
  };

  const tabListNew = useTabList({
    assessmentDetails,
    hideIt,
    overrideToggle,
    setShowWound,
    updateCharStatus,
    getCharDetails,
  });

  const { defaultIndex, setDefaultIndex, prevDefaultIndex } = useDefaultIndex(tabListNew);

  useCharacteristicInit({ setDefaultIndex, prevDefaultIndex });

  const isLoading = tabListNew.length === 0 || charStatus.length === 0;

  return (
    <div>
      <span className="d-none">{assessmentDetails?.anatomy}</span>

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {prevDefaultIndex.current !== defaultIndex && (
            <VerticalTab tabList={tabListNew} dispatch={dispatch} defaultIndex={defaultIndex} showwound={showwound} setShowWound={setShowWound} />
          )}
          {prevDefaultIndex.current === defaultIndex && (
            <VerticalTab tabList={tabListNew} dispatch={dispatch} defaultIndex={defaultIndex} showwound={showwound} setShowWound={setShowWound} />
          )}
        </>
      )}
    </div>
  );
};
